import { Send, Eye, Download, File, FileText } from "lucide-react";
import { memo } from "react";

const AttachmentList = memo(({ attachments = [], onSendAttachment }) => {
  const formatFileSize = (bytes) => {
    if (!bytes) return "0 KB";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return (bytes / Math.pow(k, i)).toFixed(1) + " " + sizes[i];
  };

  const getFileIcon = (fileName) => {
    if (!fileName) return <File className="h-4 w-4 text-gray-500" />;
    const ext = fileName.split(".").pop().toLowerCase();
    if (["pdf"].includes(ext))
      return <FileText className="h-4 w-4 text-red-500" />;
    if (["jpg", "jpeg", "png", "gif"].includes(ext))
      return <File className="h-4 w-4 text-blue-500" />;
    if (["mp4", "avi", "mkv"].includes(ext))
      return <File className="h-4 w-4 text-purple-500" />;
    if (["mp3", "wav"].includes(ext))
      return <File className="h-4 w-4 text-green-500" />;
    return <File className="h-4 w-4 text-gray-500" />;
  };

  if (attachments.length === 0) {
    return (
      <div className="py-3 text-center text-sm text-gray-500 dark:text-gray-400">
        Nenhum anexo encontrado.
      </div>
    );
  }

  return (
    <div className="max-h-40 overflow-y-auto border-t border-gray-200 dark:border-gray-700">
      {attachments.map((att) => (
        <div
          key={att.id}
          className="flex items-center justify-between border-b border-gray-100 px-1 py-2 text-sm transition-colors hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-800"
        >
          {/* Arquivo + Nome */}
          <div className="flex items-center space-x-2 overflow-hidden">
            {getFileIcon(att.fileName)}
            <div className="truncate">
              <p className="max-w-[150px] truncate text-gray-800 dark:text-gray-200">
                {att.name || "Arquivo sem nome"}
              </p>
              {att.fileSize && (
                <p className="text-xs text-gray-400 dark:text-gray-500">
                  {formatFileSize(att.fileSize)}
                </p>
              )}
            </div>
          </div>

          {/* Ações */}
          <div className="flex items-center space-x-2">
            <a
              href={`${process.env.REACT_APP_URL}${att.filePath}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center rounded bg-blue-50 p-1 text-blue-600 transition-colors hover:bg-blue-100 dark:bg-blue-900/20 dark:text-blue-400 dark:hover:bg-blue-900/40"
              title="Visualizar"
            >
              <Eye className="h-4 w-4" />
            </a>
            <a
              href={`${process.env.REACT_APP_URL}${att.filePath}`}
              target="_blank"
              rel="noopener noreferrer"
              download={att.fileName}
              className="flex items-center rounded bg-purple-50 p-1 text-purple-600 transition-colors hover:bg-purple-100 dark:bg-purple-900/20 dark:text-purple-400 dark:hover:bg-purple-900/40"
              title="Baixar"
            >
              <Download className="h-4 w-4" />
            </a>
            <button
              onClick={() => onSendAttachment(att)}
              className="flex items-center rounded bg-green-50 p-1 text-green-600 transition-colors hover:bg-green-100 dark:bg-green-900/20 dark:text-green-400 dark:hover:bg-green-900/40"
              title="Enviar"
            >
              <Send className="h-4 w-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
});

export default AttachmentList;
